<template>
  <!-- 退款审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <jr-select
            title="退款审核状态"
            select-style="max-width: 110px;"
            v-model="queryForm.approvalStatus"
            :size="formSize"
            @change="refreshList"
            dictionary-type="APPROVAL_STATUS"
          />
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <!-- 批量操作 -->
            <btns-operate
              :isBatch="true"
              :multipleSelection="multipleSelection"
              @success="getList"
            />
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          @selection-change="handleSelectionChange"
          ref="paymentApplyListRef"
        >
          <template v-slot:options="{row}">
            <btns-operate
              :current="row"
              @success="getList"
            />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :refund-no.sync="refundNo"
      @operate-success="getList"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
    />
  </div>
</template>

<script>
import { getPaymentRefund } from '@/api/approval/refund';
import detail from './components/detail';
import BtnsOperate from './components/btns-operate';
import { setStatusColor } from '@/filters/index';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  approvalStatus: '', // 审核状态 1 待审核 2 已通过 -1 已驳回 -2 已取消 0 取消中
  transType: 2,
  timeType: '1',
};

export default {
  name: 'ApprovalPaymentRefund',
  components: { detail, BtnsOperate },
  data() {
    const list = [
      {
        value: '1',
        label: '退款申请编号',
      }, {
        value: '2',
        label: '业务订单编号',
      }, {
        value: '3',
        label: '付款退款单编号',
      },
      {
        value: '4',
        label: '供应商编号',
      },
    ];
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '审核时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            ...list,
            {
              value: '5',
              label: '供应商名称',
            },
          ],
        },
      ],
      batchSearchTypeList: [ // 批量搜索搜索条件集合
        ...list,
      ],
      isDetailShow: false, // 详情弹窗
      refundNo: '', // 退款审核编号
      isBatchSearchShow: false, // 批量搜索
      isBatch: false, // 是否批量操作
      batchResults: {}, // 批量操作-返回结果
      multipleSelection: [], // 批量操作-选中的数据
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          align: 'center',
          isShow: () => false,
          show: () => this.$has('FWS-KJSH-FKTK-TGBH'),
          selectable: (row) => this.setDisabled(row),
        },
        {
          prop: 'refundNo',
          label: '付款退款单编号',
          minWidth: '1',
          disabled: true,
          click: (row) => this.handleDetail(row),
          show: () => this.$has('FWS-KJSH-FKTK-XQ'),
        },
        { prop: 'refundApplyNo', label: '退款申请编号', minWidth: '1' },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'businessName', label: '供应商名称', minWidth: '1' },
        { prop: 'businessNo', label: '供应商编号', minWidth: '1' },
        { prop: 'refundWayDesc', label: '退款方式', minWidth: '1' },
        { prop: 'refundAmount', label: '申请退款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'payAmount', label: '应付金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'paidAmount', label: '实付金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'refundReason', label: '退款原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'cruser', label: '申请人', minWidth: '1' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          label: '审核状态',
          prop: 'approvalStatus',
          status: 'approvalStatus',
          statusDesc: 'approvalStatusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { prop: 'approvalUser', label: '操作人', minWidth: '1' },
        { prop: 'operate', slotName: 'options', label: '操作', width: '160', show: () => this.$has('FWS-KJSH-FKTK-TGBH'), disabled: true },
      ],
      recommendedColumn: [
        { prop: 'approvalTime', label: '审核时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'rejectReason', label: '驳回原因', minWidth: '1', showOverflowTooltip: true },
      ],
      selectTableColumn: [],
      columnsKey: 'fwsPaymentRefundList',
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { approvalStatus } = this.$route.query;
      this.queryForm.approvalStatus = approvalStatus || '';
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.paymentApplyListRef.doLayout();
      });
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    getList() {
      this.getRefundList(this.queryForm);
    },
    // 列表接口请求
    async getRefundList(param, isBatch = false) {
      try {
        this.isBatch = isBatch;
        this.loading = true;
        this.list = [];
        const res = await getPaymentRefund(param);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.approvalStatus)) {
        return 1;
      }
      return 0;
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getRefundList(param, true);
    },
    // 详情
    handleDetail(row) {
      this.refundNo = row?.refundNo || '';
      this.isDetailShow = true;
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 操作成功后调用
    handleOperateStateResults() {
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>
